import { render } from "./DurationGeneric.vue?vue&type=template&id=483059b8"
import script from "./DurationGeneric.vue?vue&type=script&lang=ts"
export * from "./DurationGeneric.vue?vue&type=script&lang=ts"
script.render = render

export default script